import React from 'react'; 
import './whatGPT3.css';
import { Feature } from '../../Components';

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature title="Inside of AI" text="We hold the view, friends, a message brings joy. Entire forefront, a plate heard, oh, necessary. His flaws neither convinced residence his own. Connection makes having lively personal apartments impossible. In jointure, a lady insists on humanity so. A welcoming bachelor entrance, onward." />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">The possibilities transcend your imagination</h1>
      <p>Discover the Repository</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature title="Chatbots" text="We so opinion friends me message as delight. Whole front do of plate heard oh ought." />
      <Feature title="Knowledgebase" text="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b" />
      <Feature title="Education" text="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b" />
    </div>
  </div>
);

export default WhatGPT3;